export function detectAdBlock() {
  const googleAdUrl = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';

  return fetch(new Request(googleAdUrl))
    .then((_) => false)
    .catch((_) => true);
}
